var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.makeLink && _vm.projectId > 0)?_c('RouterLink',{attrs:{"to":{ name: 'project-details', params: { projectId: _vm.projectId } }}},[_vm._v(_vm._s(_vm.projectName))]):_c('span',[_vm._v(_vm._s(_vm.projectName))])}
var staticRenderFns = []

export { render, staticRenderFns }